<template>
  <el-card>
  <div>
  合同状态
  </div>
</el-card>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>

<style scoped>
  .el-card {
    margin: 0 20px
  }
  
</style>
